import Vue from 'vue';
import _debounce from 'lodash.debounce';
import {
  STATUS_IDLE,
  STATUS_PAUSE,
  STATUS_WATCH_CREDITS,
  STATUS_INTERACTION,
  STATUS_LOADING,
  STATUS_PLAYING,
  MAX_VOLUME,
  MIN_VOLUME,
} from './enums'

import storage from './storage';
import { updateLSSettings } from './store/settings'

export class PlayerStore {
  constructor (state, holderId) {
    const settings = storage.playerSettings?.[holderId] || {}
    const BASE_STATE = {
      holderId,
      playerStatus: STATUS_LOADING,
      duration: 0,
      progress: 0,
      isBuffering: false,
      mute: typeof settings.mute !== 'undefined' ? settings.mute : false,
      product: {},
      volume: settings.volume || MAX_VOLUME,
      layers: [],
      overlayStatus: STATUS_INTERACTION,
      playerInterrupted: false,
      showSeasons: false,
      showPaused: false,
      showOptions: false,
      nextEpisode: {},
      blockKeyboard: false,
      timeToIdle: 5000
    }

    this.state = Vue.observable(Object.assign(BASE_STATE, state))

    this.setIdle = _debounce(() => {
      const state = this.state
      if (
        state.playerStatus === STATUS_PAUSE ||
        state.overlayStatus === STATUS_WATCH_CREDITS ||
        state.isSeeking
      ) {
        return;
      }
      this.closeSubOverlays();
      this.setOverlayStatus(STATUS_IDLE);
    }, this.state.timeToIdle)
  }

  addLayer (layer) {
    this.state.layers.push(layer)
  }

  setBuffering (isBuffering) {
    this.state.isBuffering = isBuffering;
  }

  setPlayerStatus (status) {
    this.state.playerStatus = status;
    if (this.state.playerStatus === STATUS_PLAYING) {
      this.state.showPaused = false
    }
    if (this.state.playerStatus === STATUS_PAUSE && this.state.showOptions === false) {
      this.state.showPaused = true
    }
  }

  setOverlayStatus (status) {
    this.state.overlayStatus = status;
  }

  setInterruptedStatus (status) {
    this.state.playerInterrupted = status;
  }

  setDuration (seconds) {
    this.state.duration = seconds;
  }

  setProgress (seconds) {
    const state = this.state
    if (seconds <= 0) {
      return state.progress = 0
    }
    if (seconds > state.duration) {
      return state.progress = state.duration
    }
    state.progress = seconds
  }

  toggleMute (value) {
    const state = this.state
    state.mute = value || !state.mute;
    updateLSSettings({ mute: state.mute }, state.holderId)
  }

  setVolume (value) {
    const state = this.state
    if (state.mute) {
      this.toggleMute();
    }
    if (value > MAX_VOLUME) {
      state.volume = MAX_VOLUME;
    } else if (value <= MIN_VOLUME) {
      state.volume = MIN_VOLUME;
      if (!state.mute) {
        this.toggleMute();
      }
    } else {
      state.volume = value;
    }

    updateLSSettings({ volume: state.volume }, state.holderId)
  }

  // toggleSeasons () {
  //   const show = this.state.showSeasons;
  //   this.closeSubOverlays(show);
  //   this.state.showSeasons = !show;
  // }

  toggleOptions () {
    const show = this.state.showOptions;
    this.closeSubOverlays(show);
    this.state.showOptions = !show;
    if (this.state.showOptions === false && this.state.playerStatus === STATUS_PAUSE) {
      this.state.showPaused = true
    }
  }

  isAnySubOverlayOpen() {
    return this.state.showOptions || this.state.showSeasons || this.state.showPaused
  }

  toggleBlockKeyboard () {
    const state = this.state
    state.blockKeyboard = !state.blockKeyboard
  }

  closeSubOverlays(dontClose = false) {
    if (dontClose) {
      return;
    }
    this.state.showOptions = false;
    this.state.showPaused = false;
    this.state.showSeasons = false;
  }

  setProduct(product) {
    this.state.product = product;
    // if (product.type === ProductTypes.EPISODE) {
    //   const season = state.product.season;
    //   const serialId = season.serial.id;
    //   const episodes = await getEpisodes(season, serialId);
    //   state.nextEpisode = await getNextEpisode(episodes, product.episode, serialId, season.number);
    // }
  }

  // getEpisodes(season, serialId) {
  //   // return new Episodes()
  //   //   .fetchAll('', {
  //   //     serialId,
  //   //     seasonId: season.id,
  //   //     reset: true,
  //   //   })
  //   //   .then((episodes) => {
  //   //     return episodes.map((episode) => {
  //   //       if (episode.season) {
  //   //         return episode;
  //   //       }
  //   //       return {
  //   //         ...episode,
  //   //         season,
  //   //       };
  //   //     });
  //   //   });
  // },

  // findNextEpisode(episodes, episodeNumber = 0) {
  //   return episodes
  //     .filter(({ episode }) => episode > episodeNumber)
  //     .sort((a, b) => a.episode - b.episode)[0];
  // }
  //
  // getSeason(seasons, seasonNumber = 0) {
  //   return seasons
  //     .filter(({ number }) => number > seasonNumber)
  //     .sort((a, b) => a.number - b.number)[0];
  // }

  // getNextEpisode(episodes, productEpisode, serialId, serialNumber) {
  //   const nextEpisode = findNextEpisode(episodes, productEpisode);
  //   if (!nextEpisode) {
  //     return findNextEpisodeFromNextSeason(serialId, serialNumber);
  //   }
  //   return nextEpisode;
  // }
}
//
// async function findNextEpisodeFromNextSeason(serialId, serialNumber) {
//   // const seasons = await new Seasons({ id: serialId })
//   //   .fetchAll()
//   //   .then((seasons) => {
//   //     return seasons.map((season) => ({
//   //       ...season,
//   //       serial: {
//   //         id: serialId,
//   //       },
//   //     }));
//   //   });
//   // const season = getSeason(seasons, serialNumber);
//   // const episodes = await getEpisodes(season, serialId);
//   // return findNextEpisode(episodes);
// }
